/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BundleGroup } from '../../models/bundle-group';
import { KeyType } from '../../models/key-type';

export interface GetBundleGroup$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
}

export function getBundleGroup(http: HttpClient, rootUrl: string, params: GetBundleGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroup>> {
  const rb = new RequestBuilder(rootUrl, getBundleGroup.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BundleGroup>;
    })
  );
}

getBundleGroup.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}';
